import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsThisFor() {
  const forList = ['Mujer de 65+ con desgaste o artritis que quiere recuperar independencia', 'Está cansada de depender de pastillas', 'Quiere soluciones que pueda aplicar hoy desde casa'];
  const notForList = ['Deportistas de alto rendimiento', 'Personas que buscan una solución mágica sin aplicar cambios', 'Quien no está dispuesta a dedicar 15 minutos al día'];
  return <section className="py-20 px-6 bg-white" data-id="element-175">
      <div className="max-w-5xl mx-auto" data-id="element-176">
        <FadeIn data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-brand-brown mb-16" data-id="element-178">
            ¿Es Para Usted?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-179">
          <FadeIn delay={0.2} data-id="element-180">
            <div className="bg-brand-sage bg-opacity-10 p-8 md:p-10 rounded-2xl h-full border border-brand-sage border-opacity-30" data-id="element-181">
              <h3 className="text-2xl font-serif font-bold text-brand-brown mb-8 flex items-center gap-4" data-id="element-182">
                <div className="bg-green-100 p-2 rounded-full" data-id="element-183">
                  <Check className="w-6 h-6 text-green-700" data-id="element-184" />
                </div>
                Esto ES para usted si…
              </h3>
              <ul className="space-y-6" data-id="element-185">
                {forList.map((item, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-brand-dark" data-id="element-186">
                    <Check className="w-6 h-6 text-brand-sage flex-shrink-0 mt-1" data-id="element-187" />
                    <span className="leading-relaxed" data-id="element-188">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-189">
            <div className="bg-red-50 p-8 md:p-10 rounded-2xl h-full border border-red-100" data-id="element-190">
              <h3 className="text-2xl font-serif font-bold text-brand-brown mb-8 flex items-center gap-4" data-id="element-191">
                <div className="bg-red-100 p-2 rounded-full" data-id="element-192">
                  <X className="w-6 h-6 text-red-700" data-id="element-193" />
                </div>
                Esto NO es para usted si…
              </h3>
              <ul className="space-y-6" data-id="element-194">
                {notForList.map((item, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-brand-dark" data-id="element-195">
                    <X className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-196" />
                    <span className="leading-relaxed" data-id="element-197">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}